import React from 'react';
import cs from 'classnames';

import SearchForm from '../searchform/searchform';

import css from './index.css';
import sharedCSS from '../shared.css';

const Landing = () => (
  <div className={cs(sharedCSS.widewrap, css.root, css.rootPositioned, 'qa-content')}>
    <div className={cs(css.loadsSheet, css.nobg)}>
      <div className={css.loadsWrap}>
        <div className={css.loadsHeader}>
          <div className={css.productName}>
            <img
              width='789' height='41'
              className={css.productLogo}
              src='/assets/logo-long.svg'
              alt='Trucker Path. Truckloads'
            />
          </div>
          <div className={css.slogan}>
            The #1 free load board for finding your next haul
          </div>
        </div>
        <div className={css.loadsFormWrap}>
          <div className={css.loadsForm}>
            <SearchForm
              autoFocus={true}
              isHugeShortForm={true}
              placeholders={{
                origin: 'Enter your pickup location',
                dho: 'miles',
                dhd: 'miles',
              }}
            />
          </div>
        </div>
      </div>
    </div>

  </div>
);

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing/index.js